import React from "react"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"

const AvatarEl = styled.div`
  background: ${({ theme }) => theme.greyLight};
  border-radius: 100%;
  flex: none;
  height: 30px;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  width: 30px;

  img {
    height: auto;
    max-width: 100%;
  }

  ${(props) =>
    props.$size &&
    css`
      height: ${props.$size}px;
      width: ${props.$size}px;
    `}
`

const Avatar = ({ className, children, size }) => (
  <AvatarEl className={className} $size={size}>
    {children}
  </AvatarEl>
)

Avatar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.number,
}

export default Avatar
